module.exports = __webpack_public_path__ + "static/media/conversationcreate.b6966321.svg";